import api from './api';

const documentService = {
  uploadDocument: async (applicationId, file, type) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    
    const res = await api.post(`/applications/${applicationId}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return res.data;
  },
  getDocuments: async (applicationId) => {
    const res = await api.get(`/applications/${applicationId}/documents`);
    return res.data;
  },
  // /documents/{id} returns JSON metadata (DocumentController@show); the file itself is only at
  // .../download (DocumentController@download).
  getDocumentMeta: async (id) => (await api.get(`/documents/${id}`)).data,
  getDocument: async (id) => {
    const res = await api.get(`/documents/${id}/download`, { responseType: 'blob' });
    return res.data;
  },
  deleteDocument: async (id) => {
    const res = await api.delete(`/documents/${id}`);
    return res.data;
  }
};

export default documentService;
